module.exports = __webpack_public_path__ + "images/emoji/soon.a10dd43a7fb42d8820ca.png";